/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ShapeTriangleUpIcon16Light = forwardRef('ShapeTriangleUpIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.313 2.304a2 2 0 0 1 3.374 0l5.492 8.631c.847 1.332-.11 3.074-1.688 3.074H2.51c-1.578 0-2.535-1.742-1.688-3.074l5.492-8.63Zm2.53.537a1 1 0 0 0-1.687 0l-5.491 8.631a1 1 0 0 0 .844 1.537H13.49a1 1 0 0 0 .844-1.537L8.844 2.841Z" })));
});
